export const getRoleName = (roleName, language) => {
  if (!roleName || typeof roleName !== 'object') {
    return '';
  }

  const normalizedLanguage = language ? language.toUpperCase() : 'EN';
  
  if (roleName[normalizedLanguage]) {
    return roleName[normalizedLanguage];
  }

  if (roleName.EN) return roleName.EN;
  if (roleName.PT) return roleName.PT;
  if (roleName.ES) return roleName.ES;

  const values = Object.values(roleName);
  return values.length > 0 ? values[0] : '';
};

